module.exports = [
  {
    path: '/article',
    component: true,
    redirect: '/article/list',
    name: '课堂管理',
    children: [
      {
        path: 'list',
        name: '列表',
        component: () => import('@/views/article/list'),
      },
      {
        path: 'form',
        name: '表单',
        component: () => import('@/views/article/form'),
      },
    ]
  },
]


// WEBPACK FOOTER //
// ./src/router/article.js